import { RESOURCE_ADDED } from "./types/types";

export default (resource, resourceCategory) => ({
    type: RESOURCE_ADDED,
    payload: {
        resourceCategory,
        resource
    }
});